/**
 * Active-class selector — horizontal chip bar with per-class colour
 * swatches + keyboard shortcuts 1..9. Sits above the viewport when
 * any ML-labeling tool is selected. Clicking a chip sets the active
 * class for the next annotation; a colour swatch + class name are
 * echoed in the viewport HUD so the user always knows what they're
 * about to paint.
 */
import { For, Show } from "solid-js";
import { classes, activeId, setActiveId } from "../labeling/classes";

export function ClassBar(props: { brushRadius?: number; setBrushRadius?: (n: number) => void }) {
  return (
    <div class="flex flex-wrap items-center gap-1.5 border-b border-ink-300 bg-ink-100 px-4 py-1.5 text-[11px]">
      <span class="text-ink-700">class:</span>
      <For each={classes()}>
        {(c) => (
          <button
            type="button"
            class="group flex items-center gap-1.5 rounded border px-2 py-0.5 text-[10px] uppercase tracking-wider transition"
            classList={{
              "border-transparent text-white":  activeId() === c.id,
              "border-ink-300 text-ink-800 hover:text-white hover:border-ink-400": activeId() !== c.id,
            }}
            style={{ "background-color": activeId() === c.id ? c.color : undefined }}
            onClick={() => setActiveId(c.id)}
            title={`Switch to class "${c.name}"${c.shortcut ? ` (${c.shortcut})` : ""}`}
          >
            <span class="h-3 w-3 rounded-sm ring-1 ring-black/20" style={{ "background-color": c.color }} />
            {c.name}
            {c.shortcut && (
              <kbd class="ml-0.5 opacity-70">{c.shortcut}</kbd>
            )}
          </button>
        )}
      </For>
      <Show when={props.setBrushRadius != null}>
        <span class="ml-4 text-ink-700">brush:</span>
        <input type="range" min="1" max="60" step="1"
               value={props.brushRadius ?? 10}
               onInput={(e) => props.setBrushRadius?.(parseInt(e.currentTarget.value))}
               class="h-1 w-32 accent-brand" />
        <span class="font-mono text-ink-900">{props.brushRadius ?? 10}px</span>
      </Show>
    </div>
  );
}
